import src from "IMAGE";
export default { src, width: 433, height: 260, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAQklEQVR42mWMWwoAIAgEVXzf/76WRSD0MSjs7oCqlpkd3p+ZmygRKZiFxt0r4oZEVDDDaWLmW5iGXvd94VeYakQ8LJpJKp9cLKu0AAAAAElFTkSuQmCC"};
